<template>
  <div class="commentManage" v-loading="loading">
    <div class="breadcrumb">评论管理</div>

    <div class="search">
      <el-form :inline="true" :model="queryParam">
        <el-form-item>
          <el-select v-model="queryParam.searchType" style="width: 110px">
            <el-option label="评论ID" value="commentId"></el-option>
            <el-option label="评论内容" value="contentLike"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="queryParam.searchValue"
            :placeholder="searchPlaceholder"
            clearable
            style="width: 180px"
            @keyup.enter.native="clickSearch"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            v-model="queryParam.contentAuditStatus"
            style="width: 120px"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="审核中" :value="0"></el-option>
            <el-option label="通过" :value="1"></el-option>
            <el-option label="未通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParam.status" style="width: 120px">
            <el-option label="全部" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="clickReset">重置</el-button>
          <el-button type="primary" @click="clickSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="status-tabs">
      <el-button
        v-for="item in statusTabs"
        :key="item.value"
        :class="[
          'status-tab-btn',
          { 'is-active': queryParam.contentAuditStatus === item.value },
        ]"
        @click="changeAuditStatus(item.value)"
      >
        {{ item.label }}
      </el-button>
    </div>

    <div class="com-list">
      <el-table
        :data="listData"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="评论ID"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column label="评论内容" min-width="220" show-overflow-tooltip>
          <template scope="{ row }">
            <span>{{ row.content || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" min-width="170" align="center">
          <template scope="{ row }">
            <span>{{ row.publishTimeText }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户信息" min-width="150" align="center">
          <template scope="{ row }">
            <div>
              <el-button type="text" @click="routeDynamicDetail(row)">
                {{ row.uid }}
              </el-button>
            </div>
            <div>昵称：{{ row.nickName || "--" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="postId"
          label="所属动态ID"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column label="审核状态" min-width="95" align="center">
          <template scope="{ row }">
            <span>{{ row.contentAuditStatusText }}</span>
          </template>
        </el-table-column>
        <el-table-column label="驳回原因" min-width="180" show-overflow-tooltip>
          <template scope="{ row }">
            <span>{{ row.reasonText }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="95" align="center" fixed="right">
          <template scope="{ row }">
            <el-button type="text" @click="openSingleAudit(row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <el-button
        type="primary"
        :disabled="selectedRows.length === 0"
        @click="openBatchAuditDialog"
        >批量审核</el-button
      >
      <div v-show="paginationVirtualTotal > 0" class="pagination-seq">
        <el-pagination
          layout="total, prev, next"
          :current-page="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="paginationVirtualTotal"
          @current-change="changeCurrentPage"
        >
        </el-pagination>
        <span class="pagination-seq-hint">第 {{ queryParam.pageNum }} 页</span>
      </div>
    </div>

    <el-dialog
      title="评论审核"
      size="tiny"
      :modal-append-to-body="false"
      v-model="auditDialog.visible"
    >
      <el-form label-width="86px">
        <el-form-item label="审核状态">
          <el-select
            v-model="auditDialog.contentAuditStatus"
            style="width: 220px"
            @change="onAuditStatusChange"
          >
            <el-option label="通过" :value="1"></el-option>
            <el-option label="未通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="auditDialog.contentAuditStatus === 2"
          label="驳回原因"
        >
          <el-select
            v-model="auditDialog.reasonPresetKey"
            clearable
            filterable
            placeholder="请选择事由类型（可选）"
            style="width: 220px"
            @change="onReasonPresetChange"
          >
            <el-option
              v-for="item in reasonPresetOptions"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
          <el-input
            v-if="auditDialog.reasonPresetKey === reasonPresetOtherKey"
            v-model.trim="auditDialog.reasonExtra"
            type="textarea"
            :rows="2"
            :maxlength="50"
            placeholder="请输入驳回原因（最多50字）"
            show-word-limit
            class="reason-extra-input"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-tip">
        人工审核不通过时，APP 端该条评论删除，后台仍保留记录。
      </div>
      <div slot="footer">
        <el-button @click="auditDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitAudit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const LOG_TAG_COMMENT_AUDIT = "[CommentAudit]";

export default {
  data() {
    return {
      loading: false,
      queryParam: this.getDefaultQueryParam(),
      statusTabs: [
        { label: "全部", value: -1 },
        { label: "审核中", value: 0 },
        { label: "通过", value: 1 },
        { label: "未通过", value: 2 },
      ],
      listData: [],
      selectedRows: [],
      cursorTrail: [],
      listHasMore: false,
      paginationVirtualTotal: 0,
      reasonPresetOtherKey: "__other__",
      reasonPresetOptions: [
        { key: "illegal", label: "发布违规内容" },
        { key: "spam", label: "恶意刷屏 / 灌水" },
        { key: "harass", label: "骚扰 / 攻击他人" },
        { key: "ad", label: "广告 / 引流营销" },
        { key: "other", label: "内容不适宜展示" },
        { key: "__other__", label: "其他（自定义输入）" },
      ],
      auditDialog: {
        visible: false,
        ids: [],
        contentAuditStatus: 1,
        reasonPresetKey: "",
        reasonExtra: "",
      },
    };
  },
  computed: {
    searchPlaceholder() {
      return this.queryParam.searchType === "commentId"
        ? "精准搜索"
        : "模糊搜索";
    },
  },
  mounted() {
    this.queryList();
  },
  methods: {
    getDefaultQueryParam() {
      return {
        searchType: "commentId",
        searchValue: "",
        contentAuditStatus: -1,
        status: -1,
        publishTimeAsc: false,
        pageNum: 1,
        pageSize: 20,
      };
    },
    isRequestSuccess(errorCode) {
      return errorCode === 10000 || errorCode === 0;
    },
    resolveHasMore(data) {
      if (data && typeof data.hasMore === "boolean") {
        return data.hasMore;
      }
      return (
        data &&
        data.nextCursorPublishTime !== undefined &&
        data.nextCursorPublishTime !== null
      );
    },
    resetCursorPagination() {
      this.cursorTrail = [];
      this.listHasMore = false;
    },
    updatePaginationTotal() {
      if (!this.listData.length && this.queryParam.pageNum === 1) {
        this.paginationVirtualTotal = 0;
        return;
      }
      const basePage = Number(this.queryParam.pageNum) || 1;
      const virtualPageCount = basePage + (this.listHasMore ? 1 : 0);
      this.paginationVirtualTotal = virtualPageCount * this.queryParam.pageSize;
    },
    buildQueryBody() {
      const body = {
        publishTimeAsc: !!this.queryParam.publishTimeAsc,
        limit: this.queryParam.pageSize,
      };
      const value = String(this.queryParam.searchValue || "").trim();
      if (value !== "") {
        if (this.queryParam.searchType === "commentId") {
          body.commentId = Number(value);
        } else if (this.queryParam.searchType === "contentLike") {
          body.contentLike = value;
        }
      }
      if (this.queryParam.contentAuditStatus !== -1) {
        body.contentAuditStatus = Number(this.queryParam.contentAuditStatus);
      }
      const pageNum = Number(this.queryParam.pageNum) || 1;
      if (pageNum >= 2) {
        const cursor = this.cursorTrail[pageNum - 2];
        if (cursor !== undefined && cursor !== null) {
          body.cursorPublishTime = cursor;
        }
      }
      return body;
    },
    queryList() {
      const pageNum = Number(this.queryParam.pageNum) || 1;
      if (pageNum >= 2) {
        const cursor = this.cursorTrail[pageNum - 2];
        if (cursor === undefined || cursor === null) {
          this.$message.warning("分页游标缺失，已回到第一页");
          this.queryParam.pageNum = 1;
          this.resetCursorPagination();
        }
      }
      this.loading = true;
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v2/operate/comment/v70300/list",
        body: JSON.stringify(this.buildQueryBody()),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (!this.isRequestSuccess(result.error)) {
            this.$message.error(result.message || "查询失败");
            this.listData = [];
            this.selectedRows = [];
            this.listHasMore = false;
            this.updatePaginationTotal();
            return;
          }
          const data = result.data || {};
          const list = data.list || [];
          const current = Number(this.queryParam.pageNum) || 1;
          this.listData = list.map((item) => this.formatItem(item));
          this.selectedRows = [];
          this.listHasMore = this.resolveHasMore(data);
          if (data.nextCursorPublishTime !== undefined) {
            this.$set(
              this.cursorTrail,
              current - 1,
              data.nextCursorPublishTime
            );
          }
          this.updatePaginationTotal();
        })
        .catch((err) => {
          console.error(LOG_TAG_COMMENT_AUDIT, "queryList error", err);
          this.$message.error("查询失败");
          this.listData = [];
          this.selectedRows = [];
          this.listHasMore = false;
          this.updatePaginationTotal();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatItem(item) {
      return {
        ...item,
        publishTimeText: this.formatDateTime(item.publishTime),
        contentAuditStatusText: this.resolveAuditStatusText(
          item.contentAuditStatus
        ),
        reasonText: this.formatReasonText(item.reason),
      };
    },
    formatDateTime(value) {
      if (!value) {
        return "--";
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return "--";
      }
      const yyyy = date.getFullYear();
      const MM = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      return `${yyyy}/${MM}/${dd} ${hh}:${mm}:${ss}`;
    },
    resolveAuditStatusText(status) {
      const map = {
        0: "审核中",
        1: "通过",
        2: "未通过",
      };
      return map[Number(status)] || "--";
    },
    formatReasonText(value) {
      const text = String(value == null ? "" : value).trim();
      return text || "--";
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || [];
    },
    clickSearch() {
      if (
        this.queryParam.searchType === "commentId" &&
        this.queryParam.searchValue
      ) {
        const id = Number(this.queryParam.searchValue);
        if (!Number.isInteger(id) || id <= 0) {
          this.$message.warning("评论ID必须为正整数");
          return;
        }
      }
      this.queryParam.pageNum = 1;
      this.resetCursorPagination();
      this.queryList();
    },
    clickReset() {
      this.queryParam = this.getDefaultQueryParam();
      this.selectedRows = [];
      this.resetCursorPagination();
      this.queryList();
    },
    changeAuditStatus(status) {
      this.queryParam.contentAuditStatus = status;
      this.queryParam.pageNum = 1;
      this.resetCursorPagination();
      this.queryList();
    },
    changeCurrentPage(pageNum) {
      const target = Number(pageNum);
      const current = Number(this.queryParam.pageNum) || 1;
      if (target === current) {
        return;
      }
      if (target === 1) {
        this.queryParam.pageNum = 1;
        this.resetCursorPagination();
        this.queryList();
        return;
      }
      if (target === current + 1) {
        if (!this.listHasMore) {
          this.$message.warning("当前已是最后一页");
          return;
        }
        const cursor = this.cursorTrail[current - 1];
        if (cursor === undefined || cursor === null) {
          this.$message.warning("分页游标缺失，请从第一页重新查询");
          this.queryParam.pageNum = 1;
          this.resetCursorPagination();
          this.queryList();
          return;
        }
        this.queryParam.pageNum = target;
        this.queryList();
        return;
      }
      if (target === current - 1 && current > 1) {
        this.queryParam.pageNum = target;
        this.queryList();
        return;
      }
      this.$message.warning("游标分页不支持跳页，请逐页查看");
    },
    openSingleAudit(row) {
      this.auditDialog.visible = true;
      this.auditDialog.ids = [row.id];
      this.auditDialog.contentAuditStatus =
        Number(row.contentAuditStatus) === 2 ? 2 : 1;
      this.auditDialog.reasonPresetKey = "";
      this.auditDialog.reasonExtra = "";
    },
    openBatchAuditDialog() {
      const ids = this.selectedRows.map((item) => item.id).filter(Boolean);
      if (!ids.length) {
        this.$message.warning("请先选择评论");
        return;
      }
      this.auditDialog.visible = true;
      this.auditDialog.ids = ids;
      this.auditDialog.contentAuditStatus = 1;
      this.auditDialog.reasonPresetKey = "";
      this.auditDialog.reasonExtra = "";
    },
    onAuditStatusChange(val) {
      if (Number(val) !== 2) {
        this.auditDialog.reasonPresetKey = "";
        this.auditDialog.reasonExtra = "";
      }
    },
    onReasonPresetChange(val) {
      if (val !== this.reasonPresetOtherKey) {
        this.auditDialog.reasonExtra = "";
      }
    },
    buildAuditReason() {
      if (Number(this.auditDialog.contentAuditStatus) !== 2) {
        return "";
      }
      const key = this.auditDialog.reasonPresetKey;
      if (!key) {
        return "";
      }
      if (key === this.reasonPresetOtherKey) {
        return String(this.auditDialog.reasonExtra || "")
          .trim()
          .slice(0, 50);
      }
      const hit = this.reasonPresetOptions.find((item) => item.key === key);
      return hit ? hit.label : "";
    },
    submitAudit() {
      const ids = this.auditDialog.ids || [];
      if (!ids.length) {
        this.$message.warning("未找到待审核评论");
        return;
      }
      const reason = this.buildAuditReason();
      this.loading = true;
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v2/operate/comment/v70300/batch",
        body: JSON.stringify({
          ids,
          contentAuditStatus: Number(this.auditDialog.contentAuditStatus),
          reason: reason,
        }),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (!this.isRequestSuccess(result.error)) {
            this.$message.error(result.message || "操作失败");
            return;
          }
          this.$message.success("操作成功");
          this.auditDialog.visible = false;
          this.queryList();
        })
        .catch((err) => {
          console.error(LOG_TAG_COMMENT_AUDIT, "submitAudit error", err);
          this.$message.error("操作失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    routeDynamicDetail(row) {
      window.open("/#/yunying/community/user/list?uid=" + row.uid);
    },
  },
};
</script>

<style scoped>
.commentManage .search {
  margin: 16px 0;
}

.status-tabs {
  padding: 6px 20px 14px;
  display: inline-flex;
}

.status-tab-btn {
  min-width: 64px;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #409eff;
  border-radius: 0;
  color: #409eff;
  background: #fff;
  font-size: 14px;
}

.status-tab-btn + .status-tab-btn {
  margin-left: -1px;
}

.status-tab-btn:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.status-tab-btn:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.status-tab-btn.is-active {
  background: #409eff;
  color: #fff;
}

.pagination-wrapper {
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-seq {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pagination-seq-hint {
  color: #606266;
}

.dialog-tip {
  color: #909399;
  font-size: 12px;
}

.reason-extra-input {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// commentManage.vue?3130e138